import React from 'react';
import SecondaryButton from './SecondaryButton';
import Reveal from './Reveal';
import WordReveal from './WordReveal';

const About: React.FC = () => {
  return (
    <section id="sobre" className="py-24 bg-white">
      <div className="container mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <Reveal threshold={0.2}>
            <div className="relative">
              <div className="aspect-square rounded-3xl overflow-hidden shadow-2xl">
                <img 
                  src="https://i.imgur.com/R7uJGcU.jpeg" 
                  alt="Usinas Energy Solaris" 
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute -bottom-8 -right-8 bg-[#39B54A] p-8 rounded-3xl hidden md:block shadow-2xl">
                <p className="text-4xl font-black text-white">Total</p>
                <p className="text-white font-bold opacity-90">Assistência técnica</p>
              </div>
            </div>
          </Reveal>

          <div className="space-y-6">
            <Reveal delay={100}>
              <h2 className="text-xs font-black tracking-[0.2em] text-[#39B54A] uppercase">Sobre a Energy Solaris</h2>
            </Reveal>
            
            <div className="text-4xl md:text-5xl font-black leading-tight text-gray-900">
              <WordReveal 
                text="Excelência técnica e comprometimento com seu resultado." 
                delay={200} 
                stagger={50} 
              />
            </div>
            
            <div className="text-gray-600 leading-relaxed text-lg font-medium">
              <WordReveal 
                text="Na Energy Solaris, não apenas instalamos painéis; projetamos o futuro da sua economia. Com foco em tecnologia de ponta e transparência total, oferecemos soluções completas para empresas que buscam independência energética." 
                delay={600} 
                stagger={20} 
              />
            </div>

            <ul className="space-y-4">
              {[
                "Tecnologia fotovoltaica de última geração",
                "Engenharia especializada e dedicada",
                "Monitoramento em tempo real",
                "Compromisso com prazos e performance"
              ].map((item, idx) => (
                <Reveal key={idx} delay={1000 + (idx * 150)}>
                  <li className="flex items-center space-x-3 text-gray-700">
                    <div className="flex-shrink-0 w-6 h-6 rounded-full bg-[#39B54A]/10 flex items-center justify-center">
                      <svg className="w-4 h-4 text-[#39B54A]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                      </svg>
                    </div>
                    <span className="font-bold">{item}</span>
                  </li>
                </Reveal>
              ))}
            </ul>

            <Reveal delay={1600}>
              <div className="pt-6">
                <SecondaryButton 
                  text="Conhecer nossas soluções"
                  href="#solucoes"
                  className="px-10 py-5"
                />
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;